import { createGifSource } from "./gifSource";
const isGif = (url) => /^data:image\/gif[;,]/i.test(url) || /^data:[^,]*;base64,R0lGOD/.test(url);
export const loadImageSource = async (url) => {
    if (isGif(url))
        return createGifSource(url);
    const image = await new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error("Could not decode the image"));
        image.src = url;
    });
    return {
        frame: image,
        width: image.naturalWidth,
        height: image.naturalHeight,
        advance: () => false,
    };
};
